import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createNoticeAnnouncement } from '@services/registry';

export function useCreateNotice({ tenantId }) {
    const qc = useQueryClient();

    return useMutation({
        mutationFn: async ({ payload, createdBy }) => {
            return await createNoticeAnnouncement({ tenantId, payload, createdBy });
        },
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: ['notices', tenantId] });
        },
    });
}
